import { useState } from "react";
import { getLocalStorageItem, parseJSONSafely, setLocalStorageItem } from "utils/service";

// Hook
function useLocalStorage(key, initialValue) {
    // State to store our value
    // Pass initial state function to useState so logic is only executed once
    const [storedValue, setStoredValue] = useState(() => {
        const item = getLocalStorageItem(key);
        return parseJSONSafely(item, initialValue);
    });

    // Return a wrapped version of useState's setter function that ...
    // ... persists the new value to localStorage.
    const setValue = (value) => {
        try {
            // Compute from the latest state inside the updater so two rapid functional
            // updates in one tick don't both read the same stale closure value.
            setStoredValue((prev) => {
                const valueToStore = value instanceof Function ? value(prev) : value;
                setLocalStorageItem(key, valueToStore);
                return valueToStore;
            });
        } catch (error) {
            // A more advanced implementation would handle the error case
            // console.log(error);
        }
    };

    return [storedValue, setValue];
}

export default useLocalStorage;
